import Container from 'react-bootstrap/Container';

export const Footer = () => {
    return (
        <div
            className="pb-2 pt-2"
            style={{
                "backgroundColor": "#f8f9fa",
                "fontSize": "0.8rem"
            }}
        >
            <Container>
                Disclaimer: Futures and options trading involves substantial risk of loss and is not suitable for all investors.            You assume all risk when using any of the algorithms on ALM trading.
                ALM Trading and your licensor are not liable for any losses, monetary or otherwise.
                ALM Trading and your licensor do not guarantee to prevent loss or to make profits.
                Historical statistics and past performance do not guarantee future results.
            </Container>
            <Container>
                {false && 'v2'}
            </Container>
            
        </div>
    )
}